module.exports = __webpack_public_path__ + "img/cadastros-cidadaos.a69e586a.svg";